// components/DashboardTable/TableMonthRow.tsx
import { Fragment } from "react";
import { TableRow, TableCell } from "@/components/atoms/Table";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { Progress } from "@/components/atoms/Progress";
import { cn } from "@/utils/cn";
import { TableDetailRow } from "./TableDetailRow";
import { TableMonthRowProps } from "./Dashboardtable.types";

export const TableMonthRow = ({
    monthKey,
    flowsByInstrument,
    monthYear,
    monthName,
    monthTotal,
    monthAccum,
    instrumentsTypes,
    isExpanded,
    toggleExpanded,
    details,
    totalYear,
    totalColumns,
}: TableMonthRowProps) => (
    <Fragment key={monthKey}>
        <TableRow
            className={cn(
                "cursor-pointer hover:bg-gray-600 hover:bg-secondary-500 hover:text-white",
                isExpanded && "bg-secondary-500 text-white"
            )}
            onClick={() => toggleExpanded(monthKey)}
        >
            <TableCell className="capitalize font-bold flex items-center gap-2">
                {isExpanded ? <ChevronUpIcon className="h-5 w-5" /> : <ChevronDownIcon className="h-5 w-5" />}
                {monthName}
            </TableCell>
            <TableCell className="capitalize font-bold">
                {monthYear}
            </TableCell>

            {instrumentsTypes?.map((it) => {
                const value = flowsByInstrument[it.id];
                return (
                    <TableCell key={it.id} className="gap-1">
                        {value && (
                            <>
                                <span>{value.toLocaleString("es-CO", { style: "currency", currency: "COP" })}</span>
                                <Progress variant="info" showLabel value={(value * 100) / (totalYear || 1)} height="1.2rem" />
                            </>
                        )}
                    </TableCell>
                );
            })}

            <TableCell className="font-bold gap-1">
                <span>{monthTotal.toLocaleString("es-CO", { style: "currency", currency: "COP" })}</span>
                <Progress variant="warning" showLabel value={(monthTotal * 100) / (totalYear || 1)} height="1.2rem" />
            </TableCell>

            <TableCell className="font-bold gap-1">
                <span>{monthAccum.toLocaleString("es-CO", { style: "currency", currency: "COP" })}</span>
                <Progress
                    variant={(monthAccum * 100) / totalYear === 100 ? "success" : "primary"}
                    showLabel
                    value={(monthAccum * 100) / totalYear}
                    height="1.2rem"
                />
            </TableCell>
        </TableRow>

        {isExpanded && <TableDetailRow details={details} instrumentsTypes={instrumentsTypes} totalColumns={totalColumns} />}
    </Fragment>
);
